import React from "react";
import Logo from "../../Assets/LogoIcon.png";

const { dataQuickLinks, dataSupports, dataFollowUs } = require("../../Data");

export default function Footer() {
  return (
    <div className="flex flex-col gap-4 pt-8 bg-white sm:pt-16">
      <div className="flex flex-col gap-4 containers xl:flex-row xl:gap-0 ">
        {/* Image and description */}
        <div className="flex flex-col items-center gap-2 text-center xl:w-5/12 xl:text-left xl:items-start ">
          <div className="flex items-center gap-2">
            <img src={Logo} alt="MiTime Logo" className="w-8 xl:w-12" />
            <p className="text-xl font-bold text-red-logo xl:text-2xl">
              MiTime
            </p>
          </div>
          <p className="text-sm text-text-gray xl:pr-16">
            Jln. Babarsari No.2918, Kel. Catur Tunggal, Kec. Depok, Kab. Sleman,
            Daerah Istimewa Yogyakarta. Fax (2987) 28172. Telp (0531) 28176
          </p>
        </div>
        <div className="flex flex-col gap-4 md:flex-row xl:w-7/12 xl:gap-4">
          {/* Left Side */}
          <div className="flex xl:w-1/2 md:w-2/3">
            {/* Quick Links */}
            <div className="flex flex-col w-1/2 gap-2">
              <p className="text-sm font-bold">Quick Links</p>
              <ul className="flex flex-col gap-2 text-sm text-text-gray sm:text-base">
                {dataQuickLinks.map((e, index) => (
                  <a href={e.link} key={index}>
                    <li className="transition hover:text-black">{e.title}</li>
                  </a>
                ))}
              </ul>
            </div>
            {/* Support Links */}
            <div className="flex flex-col w-1/2 gap-2">
              <p className="text-sm font-bold">Supports</p>
              <ul className="flex flex-col gap-2 text-sm text-text-gray sm:text-base">
                {dataSupports.map((e, index) => (
                  <a href={e.link} key={index}>
                    <li className="transition hover:text-black">{e.title}</li>
                  </a>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Side */}
          <div className="flex xl:w-1/2 md:flex-col md:gap-8 md:w-1/3">
            {/* Follow us */}
            <div className="flex flex-col w-1/2 gap-2 md:w-full">
              <p className="text-sm font-bold">Follow Us</p>
              <ul className="flex gap-4">
                {dataFollowUs.map((e, index) => (
                  <a href={e.link} key={index}>
                    <li>
                      <img src={e.source} alt={e.alt} />
                    </li>
                  </a>
                ))}
              </ul>
            </div>
            {/* Jam Buka */}
            <div className="flex flex-col w-1/2 gap-2 md:w-full">
              <p className="text-sm font-bold">Jam Buka</p>
              <p className="flex gap-2 text-sm sm:text-base text-text-gray">
                <span>Setiap Hari</span>
                <span>09.00 - 20.00 WIB</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="py-4 border-t">
        <p className="text-sm text-center text-text-gray">
          © MiTime Resto. All rights reserved.
        </p>
      </div>
    </div>
  );
}
